(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["home-collections-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function syncCardUrls(block) {
      var useDesktopLinks = window.innerWidth > 768;

      block.querySelectorAll('[data-home-collection-item]').forEach(function (item) {
        var targetUrl = useDesktopLinks
          ? item.getAttribute('data-desktop-url')
          : item.getAttribute('data-mobile-url');

        if (!targetUrl) return;

        item.querySelectorAll('[data-action="navigate"]').forEach(function (navItem) {
          navItem.setAttribute('data-href', targetUrl);
        });

        item.querySelectorAll('a[href]').forEach(function (anchor) {
          anchor.setAttribute('href', targetUrl);
        });
      });
    }

    function initHomeCollectionsGrid(block) {
      syncCardUrls(block);

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          syncCardUrls(block);
        }, 120);
      });
    }

    document.querySelectorAll('[data-home-collections-grid]').forEach(function (block) {
      initHomeCollectionsGrid(block);
    });
  }());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["popular-items"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var DOT = 0.4; /* rem - dot diameter and gap share this value */

    /* Width for a pill spanning vCount merged dots:
       vCount dots + (vCount - 1) gaps = (2 * vCount - 1) * DOT rem */
    function pillWidth(vCount) {
      return ((2 * vCount - 1) * DOT).toFixed(2) + 'rem';
    }

    function initPopularSlider(block) {
      var track = block.querySelector('[data-popular-track]');
      var dotsContainer = block.querySelector('[data-popular-dots]');

      if (!track) return;

      var slides = Array.from(track.querySelectorAll('[data-popular-slide]'));
      if (!slides.length) return;

      var indicators = [];
      var currentIndex = 0;

      function visibleCount() {
        var sw = slides[0].offsetWidth;
        return sw > 0 ? Math.max(1, Math.round(track.offsetWidth / sw)) : 1;
      }

      /* Total indicator elements = scroll positions = slides - visible + 1
         The active element is the pill (wide); the rest are small dots. */
      function indicatorCount() {
        return Math.max(1, slides.length - visibleCount() + 1);
      }

      function buildIndicators() {
        dotsContainer.innerHTML = '';
        indicators = [];
        var n = indicatorCount();
        for (var i = 0; i < n; i++) {
          var el = document.createElement('span');
          el.className = 'popular-items__dot';
          el.setAttribute('role', 'button');
          el.setAttribute('aria-label', 'Go to item ' + (i + 1));
          (function (idx) {
            el.addEventListener('click', function () { goTo(idx); });
          }(i));
          dotsContainer.appendChild(el);
          indicators.push(el);
        }
      }

      function updateState() {
        var vCount = visibleCount();
        var max = Math.max(0, indicatorCount() - 1);
        var active = Math.min(currentIndex, max);
        var pw = pillWidth(vCount);
        indicators.forEach(function (el, i) {
          if (i === active) {
            el.style.width = pw;
            el.style.opacity = '1';
            el.style.cursor = 'default';
            el.style.pointerEvents = 'none';
          } else {
            el.style.width = DOT + 'rem';
            el.style.opacity = '0.25';
            el.style.cursor = 'pointer';
            el.style.pointerEvents = 'auto';
          }
        });
      }

      function goTo(index) {
        var max = Math.max(0, slides.length - visibleCount());
        currentIndex = Math.max(0, Math.min(index, max));
        track.scrollTo({ left: slides[currentIndex].offsetLeft, behavior: 'smooth' });
        updateState();
      }

      /* Sync pill on native scroll / touch swipe */
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var sw = slides[0] ? slides[0].offsetWidth : 1;
          currentIndex = Math.round(track.scrollLeft / sw);
          updateState();
        }, 80);
      });

      /* Rebuild on resize - visible count changes across breakpoints */
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          buildIndicators();
          updateState();
        }, 150);
      });

      buildIndicators();
      updateState();
    }

    document.querySelectorAll('.popular-items').forEach(function (block) {
      initPopularSlider(block);
    });
  }());
  } catch(e) { console.error(e); }
})();

})();
